<div class="flex flex-col gap-2 max-w-xl">
  <h3 class="font-semibold text-[15px] leading-[19px] text-[var(--text-color)]">{{ 'graphs.sections.envelopeCurves' | transloco }}</h3>
  <ces-button-secondary icon="add" [label]="'graphs.envelope.add' | transloco" (onClick)="addEnvelope.emit()" />
  @if (envelopes().length > 0) {
    <div class="flex flex-col">
      @for (envelope of envelopes(); track envelope.id) {
        <app-graph-item-row
          [name]="envelope.name"
          (configure)="configureEnvelope.emit(envelope)"
          (remove)="removeEnvelope.emit(envelope)" />
      }
    </div>
  }
</div>
